import { defaultPanelList } from './settings'
import Storage from '@/utils/storage'
import { deepClone } from '@/utils'

const storagePanelConfig = () => Storage.getItem('settingsMonitor')['panelConfig']

var getItem = function (id, key) {
  let config = storagePanelConfig()
  if (config) {
    let item = config.find(item => item.id === id)
    if (item && item.options && item.options.hasOwnProperty(key)) {
      return item.options[key]
    }
  }
  else {
    let item = defaultPanelList.find(item => item.id === id)
    if (item && item.options && item.options.hasOwnProperty(key)) {
      return item.options[key]
    }
  }
  return null
}

function getData(msg, panel, groupingKeys, size, noLimit) {
  if (!panel.options.filter) return msg
  let entries = []
  if (panel.options.filterId) {
    entries = msg.filter(m => m[panel.options.filter] === panel.options.filterId)
  } else {
    entries = msg.filter(m => m[panel.options.filter] === panel.id)
  }
  // let entries = msg.filter(m => m[panel.options.filter] === panel.id)
  if (entries.length !== 1) return []
  let entry = entries[0]
  let list = null
  let label = null

  // dynamic title
  if (entry.title) {
    panel.options.title = entry.title
    panel.options.updateTitle = true
  }

  if (panel.options.mapping && panel.options.groupKey && groupingKeys[panel.options.groupKey] && panel.options.mapping[groupingKeys[panel.options.groupKey]]) {
    list = panel.options.mapping[groupingKeys[panel.options.groupKey]].list
    label = panel.options.mapping[groupingKeys[panel.options.groupKey]].label
  }
  else {
    list = panel.options.list
    label = panel.options.label
  }
  if (list && entry[list]) {
    if (panel.id === 'BookSummary' || panel.id === 'BookDiscrepancies' || panel.id === 'RiskSplit') {
      return entries
    }
    else if (noLimit) {
      return entry[list].map(v => {
        return Object.assign(label ? { label: v[label] } : {}, v)
      })
    }
    else {
      return entry[list].slice(0, size).map(v => {
        return Object.assign(label ? { label: v[label] } : {}, v)
      })
    }

  }
  return []
}

function getExtraData(msg, panel) {
  if (msg && panel && panel.options && panel.options.filter && panel.extraKey) {
    return msg.find(m => m[panel.options.filter] === panel.extraKey) || {}
  }
  return {}
}

function getPanelList() {
  return [
    {
      id: 'BookPnL',
      dataKey: 'BookPnL',
      extraKey: 'NetExposure',
      class: 'BookPnL',
      exportExcel: 'BookPnL',
      exportExcelFilePrefix: 'FXMetals',
      bookFilterId: '',
      optionsClass: 'SettingsBook',
      optionsNoPopup: true,
      options: {
        title: 'FX/Metals',
        rootList: 'exportList',
        filter: 'sorting',
        list: 'instrumentList',
        label: 'instrumentName',
        top: getItem('BookPnL', 'top'),
        left: getItem('BookPnL', 'left'),
        width: getItem('BookPnL', 'width'),
        height: getItem('BookPnL', 'height'),
        z: getItem('BookPnL', 'z'),
        minWidth: getItem('BookPnL',  'minWidth'),
        showBookFilter: false,
        bookPnLMode: getItem('BookPnL',  'bookPnLMode'),
        lotsMios: getItem('BookPnL', 'lotsMios'),
        bookSet: getItem('BookPnL',  'bookSet'),
        showNetExposure: getItem('BookPnL', 'showNetExposure')
      }
    },
    {
      id: 'BookPnL1',
      dataKey: 'BookPnL1',
      class: 'BookPnL',
      exportExcel: 'BookPnL1',
      exportExcelFilePrefix: 'Stocks',
      bookFilterId: '',
      optionsClass: 'SettingsBook',
      optionsNoPopup: true,
      options: {
        title: 'Stocks',
        rootList: 'exportList',
        filter: 'sorting',
        list: 'instrumentList',
        label: 'instrumentName',
        top: getItem('BookPnL1', 'top'),
        left: getItem('BookPnL1', 'left'),
        width: getItem('BookPnL1', 'width'),
        height: getItem('BookPnL1', 'height'),
        z: getItem('BookPnL1', 'z'),
        minWidth: getItem('BookPnL1',  'minWidth'),
        showBookFilter: false,
        bookPnLMode: getItem('BookPnL1',  'bookPnLMode'),
        lotsMios: getItem('BookPnL1', 'lotsMios'),
        bookSet: getItem('BookPnL1',  'bookSet')
      }
    },
    {
      id: 'BookPnL2',
      dataKey: 'BookPnL2',
      class: 'BookPnL',
      exportExcel: 'BookPnL2',
      exportExcelFilePrefix: 'Crypto',
      bookFilterId: '',
      optionsClass: 'SettingsBook',
      optionsNoPopup: true,
      options: {
        title: 'Crypto',
        rootList: 'exportList',
        filter: 'sorting',
        list: 'instrumentList',
        label: 'instrumentName',
        top: getItem('BookPnL2', 'top'),
        left: getItem('BookPnL2', 'left'),
        width: getItem('BookPnL2', 'width'),
        height: getItem('BookPnL2', 'height'),
        z: getItem('BookPnL2', 'z'),
        minWidth: getItem('BookPnL2',  'minWidth'),
        showBookFilter: false,
        bookPnLMode: getItem('BookPnL2',  'bookPnLMode'),
        lotsMios: getItem('BookPnL2', 'lotsMios'),
        bookSet: getItem('BookPnL2',  'bookSet')
      }
    },
    {
      id: 'Risk',
      dataKey: 'BookPnL',
      class: 'Risk',
      exportExcel: 'BookPnL',
      exportExcelFilePrefix: 'Risk',
      bookFilterId: '',
      options: {
        title: 'Risk',
        rootList: 'exportList',
        filter: 'sorting',
        list: 'instrumentList',
        label: 'instrumentName',
        top: getItem('Risk', 'top'),
        left: getItem('Risk', 'left'),
        width: getItem('Risk', 'width'),
        height: getItem('Risk', 'height'),
        z: getItem('Risk', 'z'),
        minWidth: getItem('Risk',  'minWidth'),
        showBookFilter: false,
        bookPnLMode: getItem('Risk',  'bookPnLMode'),
        lotsMios: getItem('Risk', 'lotsMios'),
        bookSet: getItem('Risk',  'bookSet')
      }
    },
    {
      id: 'STPPnL',
      dataKey: 'STPPnL',
      class: 'STPPnL',
      exportExcel: 'STPPnL',
      exportExcelFilePrefix: 'STP',
      bookFilterId: '',
      optionsClass: 'SettingsBook',
      optionsNoPopup: true,
      options: {
        title: 'STP',
        rootList: 'exportList',
        filter: 'sorting',
        list: 'instrumentList',
        label: 'instrumentName',
        top: getItem('STPPnL', 'top'),
        left: getItem('STPPnL', 'left'),
        width: getItem('STPPnL', 'width'),
        height: getItem('STPPnL', 'height'),
        z: getItem('STPPnL', 'z'),
        minWidth: getItem('STPPnL',  'minWidth'),
        showBookFilter: false,
        bookPnLMode: getItem('STPPnL',  'bookPnLMode'),
        lotsMios: getItem('STPPnL', 'lotsMios')
      }
    },
    {
      id: 'BookDiscrepancies',
      dataKey: 'BookDiscrepancies',
      class: 'BookDiscrepancies',
      exportExcel: 'BookDiscrepancies',
      exportExcelFilePrefix: 'BookDiscrepancies',
      bookFilterId: '',
      options: {
        title: 'Book Discrepancies',
        rootList: 'exportList',
        filter: 'sorting',
        list: 'instrumentList',
        label: 'instrumentName',
        top: getItem('BookDiscrepancies', 'top'),
        left: getItem('BookDiscrepancies', 'left'),
        width: getItem('BookDiscrepancies', 'width'),
        height: getItem('BookDiscrepancies', 'height'),
        z: getItem('BookDiscrepancies', 'z'),
        minWidth: getItem('BookDiscrepancies',  'minWidth'),
        showBookFilter: false,
        bookPnLMode: getItem('BookDiscrepancies',  'bookPnLMode'),
        lotsMios: getItem('BookDiscrepancies', 'lotsMios')
      }
    },
    {
      id: 'CreditControl',
      dataKey: 'CreditControl',
      class: 'CreditControl',
      exportExcel: 'CreditControl',
      exportExcelFilePrefix: 'CreditControl',
      bookFilterId: '',
      optionsClass: 'SettingsBook',
      optionsNoPopup: true,
      options: {
        title: 'Credit Control',
        rootList: 'exportList',
        filter: 'sorting',
        list: 'clientList',
        label: 'accountName',
        top: getItem('CreditControl', 'top'),
        left: getItem('CreditControl', 'left'),
        width: getItem('CreditControl', 'width'),
        height: getItem('CreditControl', 'height'),
        minWidth: getItem('CreditControl',  'minWidth'),
        z: getItem('CreditControl', 'z'),
        showBookFilter: false
      }
    },
    {
      id: 'RiskSplit',
      dataKey: 'RiskSplit',
      class: 'RiskSplit',
      exportExcel: 'RiskSplit',
      exportExcelFilePrefix: 'RiskSplit',
      bookFilterId: '',
      optionsClass: 'SettingsBook',
      optionsNoPopup: true,
      options: {
        title: 'Risk Split',
        rootList: 'exportList',
        filter: 'sorting',
        list: 'instrumentList',
        label: 'instrumentName',
        top: getItem('RiskSplit', 'top'),
        left: getItem('RiskSplit', 'left'),
        width: getItem('RiskSplit', 'width'),
        height: getItem('RiskSplit', 'height'),
        z: getItem('RiskSplit', 'z'),
        minWidth: getItem('RiskSplit',  'minWidth'),
        showBookFilter: false,
        bookPnLMode: getItem('RiskSplit',  'bookPnLMode'),
        lotsMios: getItem('RiskSplit', 'lotsMios'),
        bookSet: getItem('RiskSplit',  'bookSet')
      }
    },
    // {
    //   id: 'Reconciliation',
    //   dataKey: 'Reconciliation',
    //   class: 'Reconciliation',
    //   exportExcel: 'Reconciliation',
    //   exportExcelFilePrefix: 'Reconciliation',
    //   bookFilterId: '',
    //   optionsClass: 'SettingsBook',
    //   optionsNoPopup: true,
    //   options: {
    //     title: 'SQF Reconciliation',
    //     rootList: 'exportList',
    //     filter: 'sorting',
    //     list: 'instrumentList',
    //     label: 'instrumentName',
    //     top: getItem('Reconciliation', 'top'),
    //     left: getItem('Reconciliation', 'left'),
    //     width: getItem('Reconciliation', 'width'),
    //     height: getItem('Reconciliation', 'height'),
    //     z: getItem('Reconciliation', 'z'),
    //     showBookFilter: false
    //   }
    // },
    {
      id: 'NTPLP',
      dataKey: 'NTPLP',
      class: 'NTPLP',
      exportExcel: 'NTPLP',
      exportExcelFilePrefix: 'NTPLP',
      bookFilterId: '',
      optionsClass: 'SettingsBook',
      optionsNoPopup: true,
      options: {
        title: 'Client NTP',
        rootList: 'exportList',
        filter: 'sorting',
        list: 'bookList',
        label: 'bookName',
        top: getItem('NTPLP', 'top'),
        left: getItem('NTPLP', 'left'),
        width: getItem('NTPLP', 'width'),
        height: getItem('NTPLP', 'height'),
        z: getItem('NTPLP', 'z'),
        showBookFilter: false
      }
    },
    {
      id: 'BookAggregation',
      dataKey: 'BookAggregation',
      class: 'BookAggregation',
      exportExcel: 'BookAggregation',
      exportExcelFilePrefix: 'BookAggregation',
      bookFilterId: '',
      options: {
        title: 'Book Aggregation',
        rootList: 'exportList',
        filter: 'sorting',
        list: 'instrumentList',
        label: 'instrumentName',
        top: getItem('BookAggregation', 'top'),
        left: getItem('BookAggregation', 'left'),
        width: getItem('BookAggregation', 'width'),
        height: getItem('BookAggregation', 'height'),
        z: getItem('BookAggregation', 'z'),
        minWidth: getItem('BookAggregation',  'minWidth'),
        showBookFilter: false,
        bookPnLMode: getItem('BookAggregation',  'bookPnLMode'),
        lotsMios: getItem('BookAggregation', 'lotsMios'),
        bookSet: getItem('BookAggregation',  'bookSet')
      }
    },
    {
      id: 'BookSummary',
      dataKey: 'BookSummary',
      class: 'BookSummary',
      exportExcel: 'BookSummary',
      exportExcelFilePrefix: 'BookSummary',
      bookFilterId: '',
      optionsClass: 'SettingsCategory',
      optionsNoPopup: true,
      options: {
        title: 'Book Summary',
        rootList: 'exportList',
        filter: 'sorting',
        list: 'instrumentList',
        label: 'instrumentName',
        top: getItem('BookSummary', 'top'),
        left: getItem('BookSummary', 'left'),
        width: getItem('BookSummary', 'width'),
        height: getItem('BookSummary', 'height'),
        z: getItem('BookSummary', 'z'),
        minWidth: getItem('BookSummary',  'minWidth'),
        showBookFilter: false
      }
    },
    {
      id: 'PnL Report',
      class: 'PnLReport',
      bookFilterId: '',
      options: {
        title: 'P/L Report',
        top: getItem('PnL Report', 'top'),
        left: getItem('PnL Report', 'left'),
        width: getItem('PnL Report', 'width'),
        height: getItem('PnL Report', 'height'),
        minWidth: getItem('PnL Report',  'minWidth'),
        z: getItem('PnL Report', 'z'),
        showBookFilter: false
      },
      subMenu: [
        {
          id: 'BookPnLReport',
          dataKey: 'PnL Report',
          class: 'BookPnLReport',
          exportExcel: 'PnL Report',
          exportExcelFilePrefix: 'BookPnLReport',
          options: {
            title: 'Book Report',
            rootList: 'exportList',
            filter: 'sorting',
            filterId: 'PnL Report',
            list: 'bookList',
            label: 'title'
          }
        },
        {
          id: 'TopExposurePnLReport',
          dataKey: 'PnL Report',
          class: 'TopExposurePnLReport',
          exportExcel: 'PnL Report',
          exportExcelFilePrefix: 'TopExposurePnLReport',
          options: {
            title: 'Top Exposure',
            rootList: 'exportList',
            filter: 'sorting',
            filterId: 'PnL Report',
            list: 'instrumentList',
            label: 'instrumentName'
          }
        }
      ]
    },
    {
      id: 'TopPosition',
      dataKey: 'TopPosition',
      class: 'InstrExpArray',
      exportExcel: 'TopPosition',
      exportExcelFilePrefix: 'TopPosition',
      bookFilterId: 'TopPosition',
      optionsClass: 'SettingsLot',
      optionsConds: [
        { groupKey: 'symbol' }
      ],
      options: {
        title: 'Top Position',
        rootList: 'exportList',
        filter: 'sorting',
        groupKey: getItem('TopPosition', 'groupKey'),
        lotsMios: getItem('TopPosition', 'lotsMios'),
        top: getItem('TopPosition', 'top'),
        left: getItem('TopPosition', 'left'),
        width: getItem('TopPosition', 'width'),
        height: getItem('TopPosition', 'height'),
        z: getItem('TopPosition', 'z'),
        defaultMapping: 'symbol',
        showBookFilter: true,
        mapping: {
          'symbol': {
            list: 'instrumentList',
            label: 'instrumentName'
          },
          'currency': {
            list: 'currencyList',
            label: 'currency'
          }
        }
      }
    },
    {
      id: 'TopLong',
      dataKey: 'TopLong',
      class: 'InstrExpArray',
      exportExcel: 'TopLong',
      exportExcelFilePrefix: 'TopLong',
      bookFilterId: 'TopLong',
      optionsClass: 'SettingsLot',
      optionsConds: [
        { groupKey: 'symbol' }
      ],
      options: {
        title: 'Top Long',
        rootList: 'exportList',
        filter: 'sorting',
        groupKey: getItem('TopLong', 'groupKey'),
        lotsMios: getItem('TopLong', 'lotsMios'),
        top: getItem('TopLong', 'top'),
        left: getItem('TopLong', 'left'),
        width: getItem('TopLong', 'width'),
        height: getItem('TopLong', 'height'),
        z: getItem('TopLong', 'z'),
        defaultMapping: 'symbol',
        showBookFilter: true,
        mapping: {
          'symbol': {
            list: 'instrumentList',
            label: 'instrumentName'
          },
          'currency': {
            list: 'currencyList',
            label: 'currency'
          }
        }
      }
    },
    {
      id: 'TopShort',
      dataKey: 'TopShort',
      class: 'InstrExpArray',
      exportExcel: 'TopShort',
      exportExcelFilePrefix: 'TopShort',
      bookFilterId: 'TopShort',
      optionsClass: 'SettingsLot',
      optionsConds: [
        { groupKey: 'symbol' }
      ],
      options: {
        title: 'Top Short',
        rootList: 'exportList',
        filter: 'sorting',
        groupKey: getItem('TopShort', 'groupKey'),
        lotsMios: getItem('TopShort', 'lotsMios'),
        top: getItem('TopShort', 'top'),
        left: getItem('TopShort', 'left'),
        width: getItem('TopShort', 'width'),
        height: getItem('TopShort', 'height'),
        z: getItem('TopShort', 'z'),
        defaultMapping: 'symbol',
        showBookFilter: true,
        mapping: {
          'symbol': {
            list: 'instrumentList',
            label: 'instrumentName'
          },
          'currency': {
            list: 'currencyList',
            label: 'currency'
          }
        }
      }
    },
    {
      id: 'TopWinning',
      dataKey: 'TopWinning',
      class: 'InstrPnLArray',
      exportExcel: 'TopWinning',
      exportExcelFilePrefix: 'TopWinning',
      bookFilterId: 'TopWinning',
      options: {
        title: 'Top Winning',
        rootList: 'exportList',
        filter: 'sorting',
        groupKey: getItem('TopWinning', 'groupKey'),
        top: getItem('TopWinning', 'top'),
        left: getItem('TopWinning', 'left'),
        width: getItem('TopWinning', 'width'),
        height: getItem('TopWinning', 'height'),
        z: getItem('TopWinning', 'z'),
        defaultMapping: 'symbol',
        showBookFilter: true,
        mapping: {
          'symbol': {
            list: 'instrumentList',
            label: 'instrumentName'
          },
          'currency': {
            list: 'currencyList',
            label: 'currency'
          }
        }
      }
    },
    {
      id: 'TopLoosing',
      dataKey: 'TopLoosing',
      class: 'InstrPnLArray',
      exportExcel: 'TopLoosing',
      exportExcelFilePrefix: 'TopLosing',
      bookFilterId: 'TopLoosing',
      options: {
        title: 'Top Losing',
        rootList: 'exportList',
        filter: 'sorting',
        groupKey: getItem('TopLoosing', 'groupKey'),
        top: getItem('TopLoosing', 'top'),
        left: getItem('TopLoosing', 'left'),
        width: getItem('TopLoosing', 'width'),
        height: getItem('TopLoosing', 'height'),
        z: getItem('TopLoosing', 'z'),
        defaultMapping: 'symbol',
        showBookFilter: true,
        mapping: {
          'symbol': {
            list: 'instrumentList',
            label: 'instrumentName'
          },
          'currency': {
            list: 'currencyList',
            label: 'currency'
          }
        }
      }
    },
    {
      id: 'Flow',
      dataKey: 'Flow',
      class: 'FlowArray',
      exportExcel: 'Flow',
      exportExcelFilePrefix: 'Flow',
      bookFilterId: 'Flow',
      options: {
        title: 'Flow PnL',
        rootList: 'exportList',
        filter: 'sorting',
        list: 'instrumentList',
        label: 'instrumentName',
        top: getItem('Flow', 'top'),
        left: getItem('Flow', 'left'),
        width: getItem('Flow', 'width'),
        height: getItem('Flow', 'height'),
        z: getItem('Flow', 'z'),
        showBookFilter: false
      }
    },
    {
      id: 'Client',
      class: 'Client',
      bookFilterId: 'TopClient',
      optionsClass: 'SettingsBook',
      optionsNoPopup: true,
      options: {
        title: 'Client',
        top: getItem('Client', 'top'),
        left: getItem('Client', 'left'),
        width: getItem('Client', 'width'),
        height: getItem('Client', 'height'),
        minWidth: getItem('Client',  'minWidth'),
        z: getItem('Client', 'z'),
        showBookFilter: true
      },
      subMenu: [
        {
          id: 'TopWinningClient',
          dataKey: 'TopWinningClient',
          class: 'ClientArray',
          exportExcel: 'TopWinningClient',
          exportExcelFilePrefix: 'TopWinningClient',
          options: {
            title: 'Top Winning Client',
            rootList: 'exportList',
            filter: 'sorting',
            list: 'clientList',
            label: 'accountName'
          }
        },
        {
          id: 'TopLoosingClient',
          dataKey: 'TopLoosingClient',
          class: 'ClientArray',
          exportExcel: 'TopLoosingClient',
          exportExcelFilePrefix: 'TopLosingClient',
          options: {
            title: 'Top Losing Client',
            rootList: 'exportList',
            filter: 'sorting',
            list: 'clientList',
            label: 'accountName'
          }
        },
        {
          id: 'TopActiveClient',
          dataKey: 'TopActiveClient',
          class: 'ClientArray',
          exportExcel: 'TopActiveClient',
          exportExcelFilePrefix: 'TopActiveClient',
          options: {
            title: 'Top Active Client',
            rootList: 'exportList',
            filter: 'sorting',
            list: 'clientList',
            label: 'accountName'
          }
        },
        {
          id: 'MonitoringClient',
          dataKey: 'MonitoringClient',
          class: 'ClientArray',
          exportExcel: 'MonitoringClient',
          exportExcelFilePrefix: 'MonitoringClient',
          options: {
            title: 'Monitoring Client',
            rootList: 'exportList',
            filter: 'sorting',
            list: 'clientList',
            label: 'accountName'
          }
        }
      ]
    },
    // {
    //   id: 'Hedging',
    //   class: 'HedgeArray',
    //   exportExcel: 'Hedging',
    //   exportExcelFilePrefix: 'Hedging',
    //   bookFilterId: '',
    //   options: {
    //     title: 'Hedging',
    //     rootList: 'exportList',
    //     filter: 'sorting',
    //     groupKey: getItem('Hedging', 'groupKey'),
    //     top: getItem('Hedging', 'top'),
    //     left: getItem('Hedging', 'left'),
    //     width: getItem('Hedging', 'width'),
    //     height: getItem('Hedging', 'height'),
    //     minWidth: getItem('Hedging',  'minWidth'),
    //     z: getItem('Hedging', 'z'),
    //     defaultMapping: 'symbol',
    //     showBookFilter: false,
    //     mapping: {
    //       'symbol': {
    //         list: 'instrumentList',
    //         label: 'instrumentName'
    //       },
    //       'currency': {
    //         list: 'currencyList',
    //         label: 'currency'
    //       }
    //     }
    //   }
    // },
    {
      id: 'Order',
      class: 'Order',
      bookFilterId: '',
      options: {
        title: 'Order',
        top: getItem('Order', 'top'),
        left: getItem('Order', 'left'),
        width: getItem('Order', 'width'),
        height: getItem('Order', 'height'),
        z: getItem('Order', 'z'),
        minWidth: getItem('Order',  'minWidth'),
        showBookFilter: false
      },
      subMenu: [
        {
          id: 'TopWorkingOrder',
          dataKey: 'TopWorkingOrder',
          class: 'OrderArray',
          exportExcel: 'TopWorkingOrder',
          exportExcelFilePrefix: 'TopWorkingOrder',
          options: {
            title: 'Top Working Orders',
            rootList: 'exportList',
            filter: 'sorting',
            list: 'orderList',
            label: 'accountName'
          }
        },
        {
          id: 'MarginCall',
          dataKey: 'MarginCall',
          class: 'MarginCallArray',
          exportExcel: 'MarginCall',
          exportExcelFilePrefix: 'MarginCall',
          options: {
            title: 'Margin Call Clients',
            rootList: 'exportList',
            filter: 'sorting',
            list: 'clientList',
            label: 'accountName'
          }
        }
      ]
    }
    // {
    //   id: 'ccyExposure',
    //   class: 'Exposure',
    //   exportExcel: 'ProfitAndLoss',
    //   exportExcelFilePrefix: 'ProfitAndLoss',
    //   bookFilterId: '',
    //   optionsClass: 'SettingsMode',
    //   options: {
    //     title: 'Profit and Loss',
    //     rootList: 'currencyList',
    //     mode: getItem('ccyExposure', 'mode'), // affichage 1 large , 2 small
    //     filter: null,
    //     top: getItem('ccyExposure', 'top'),
    //     left: getItem('ccyExposure', 'left'),
    //     minWidth: getItem('ccyExposure', 'minWidth'),
    //     width: getItem('ccyExposure', 'width'),
    //     height: getItem('ccyExposure', 'height'),
    //     z: getItem('ccyExposure', 'z'),
    //     showBookFilter: false
    //   }
    // }
  ]
}

export default {
  panelList: null,

  groupKeyList: [],

  reloadPanelConfig: function () {
    this.panelList = deepClone(defaultPanelList)
    this.validate()
    return this.panelList
  },

  getPanelConfig: function () {
    if (!this.panelList) {
      this.panelList = getPanelList()
      this.validate()
    }
    return this.panelList
  },

  reload: function () {
    this.panelList = null
  },

  validate: function() {
    this.groupKeyList = []
    let groupKeys = {}
    let defaultMappingGroup = {}
    this.panelList.forEach(p => {
      if (!p.id) throw new Error('Configuration error: panel has no id')
      if (p.id === 'groupingKeys') Error('Configuration error: panel ' + p.id + ' uses a reserved name')
      if (!p.options) throw new Error('Configuration error: panel ' + p.id + ' has no options')
      if (p.subMenu) {
        p.subMenu.forEach(s => {
          if (!s.id) throw new Error('Configuration error: panel ' + p.id + ' subpanel has no id')
          if (s.id === 'groupingKeys') Error('Configuration error: panel ' + p.id + ' subpanel ' + s.id + ' uses a reserved name')
          if (!p.options) throw new Error('Configuration error: panel ' + p.id + ' subpanel ' + s.id + ' has no options')
          if (!s.options.rootList) throw new Error('Configuration error: panel ' + p.id + ' subpanel ' + s.id + ' has no rootList option')
          if (s.options.filter) {
            if (s.options.mapping) {
              if (!s.options.groupKey) throw new Error('Configuration error: panel ' + p.id + ' subpanel ' + s.id + ' has no groupKey option')
              if (!groupKeys[s.options.groupKey]) groupKeys[s.options.groupKey] = {}
              defaultMappingGroup[s.options.groupKey] = s.options.defaultMapping
              for (var map in s.options.mapping) {
                if (!groupKeys[s.options.groupKey][map]) {
                  groupKeys[s.options.groupKey][map] = 1
                }
                else {
                  groupKeys[s.options.groupKey][map]++
                }
                if (!s.options.mapping[map].list) throw new Error('Configuration error: panel ' + p.id + ' subpanel ' + s.id + ' has no list option in mapping for ' + map)
                if (!s.options.mapping[map].label) throw new Error('Configuration error: panel ' + p.id + ' subpanel ' + s.id + ' has no label option in mapping for ' + map)
              }
            }
            else {
              if (!s.options.list) throw new Error('Configuration error: panel ' + p.id + ' subpanel ' + s.id + ' has no list option')
              if (!s.options.label) throw new Error('Configuration error: panel ' + p.id + ' subpanel ' + s.id + ' has no label option')
            }
          }
        })
      }
      else {
        if (!p.options.rootList) throw new Error('Configuration error: panel ' + p.id + ' has no rootList option')
        if (p.options.filter) {
          if (p.options.mapping) {
            if (!p.options.groupKey) throw new Error('Configuration error: panel ' + p.id + ' has no groupKey option')
            if (!groupKeys[p.options.groupKey]) groupKeys[p.options.groupKey] = {}
            defaultMappingGroup[p.options.groupKey] = p.options.defaultMapping
            for (var map in p.options.mapping) {

              if (!groupKeys[p.options.groupKey][map]) {
                groupKeys[p.options.groupKey][map] = 1
              }
              else {
                groupKeys[p.options.groupKey][map]++
              }
              if (!p.options.mapping[map].list) throw new Error('Configuration error: panel ' + p.id + ' has no list option in mapping for ' + map)
              if (!p.options.mapping[map].label) throw new Error('Configuration error: panel ' + p.id + ' has no label option in mapping for ' + map)
            }
          }
          else {
            if (!p.options.list) throw new Error('Configuration error: panel ' + p.id + ' has no list option')
            if (!p.options.label) throw new Error('Configuration error: panel ' + p.id + ' has no label option')
          }
        }
      }
    })

    for (let key in groupKeys) {
      let cnt = null
      let dfl = null
      if (defaultMappingGroup.hasOwnProperty(key))
        dfl = defaultMappingGroup[key]
      let values = []
      for (let map in groupKeys[key]) {
        //if (!dfl) dfl = map
        if (!cnt) {
          cnt = groupKeys[key][map]
        }
        else {
          if (groupKeys[key][map] !== cnt) throw new Error('Grouping key ' + key + ' accepts a value ' + map + ' that has not a mapping defined foreach panels using this key')
        }
        values.push(map)
      }
      this.groupKeyList.push({
        key: key,
        values: values,
        default: dfl
      })
    }
  },
  getGroupKeyList: function () {
    return this.groupKeyList
  },
  updatePanelData: function (msg, data, groupingKeys, size, extraData) {
    this.panelList.forEach(p => {
      if (p.id) {
        let noLimit = getItem(p.id, 'noLimit')
        if (p.subMenu) {
          p.subMenu.forEach(s => {
            if (s.options.rootList && msg[s.options.rootList]) {
              data[p.id][s.id] = getData(msg[s.options.rootList], s, groupingKeys, size, noLimit)
            }
          })
        }
        else if (p.options.rootList && msg[p.options.rootList]) {
          data[p.id] = getData(msg[p.options.rootList], p, groupingKeys, size, noLimit)
        }
        if (p.extraKey) {
          extraData[p.extraKey] = getExtraData(msg[p.options.rootList], p)
        }
      }
    })
  }
}